
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { JobsRepository } from "../../repositories";
import { GetHDSequenceRequest } from "../../domain/requests/jobs/get-hd-sequence-request";

@Injectable({ providedIn: 'root' })
export class GetHDSequenceUsecase implements UseCase<GetHDSequenceRequest, boolean> {

  constructor(private readonly jobsRepository: JobsRepository) {
  }
  
  execute(params: GetHDSequenceRequest): Observable<boolean> {
    return this.jobsRepository.GetHDSequence(params);
  }

}
